<template>
  <a-spin tip="数据加载中..." :spinning="loading">
    <div
      id="contentChart"
      :loading="true"
      style="height: 300px;width: 400px"
    ></div>
  </a-spin>
</template>

<script>
import * as echarts from "echarts";
import { content_chart } from "@/api/blog";

export default {
  name: "dailyContent",
  props: {
    blogId: null,
    dateRange: null,
  },
  data() {
    return {
      chart: {},
      loading: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.getData();
    });
  },
  watch: {
    dateRange() {
      this.getData();
    },
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("contentChart"));

    window.onresize = () => {
      // 重新绘制
      this.chart.resize();
    };
  },
  methods: {
    createChart(refDate, int_page_read_count, share_count, add_to_fav_count) {
      // 绘制图表
      this.chart.setOption({
        title: false,
        tooltip: { trigger: "axis" },
        legend: {
          data: ["阅读", "收藏", "转发"],
          selected: { 收藏: false, 转发: false },
        },
        grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
        xAxis: { type: "category", boundaryGap: false, data: refDate },
        yAxis: { type: "value" },
        series: [
          {
            name: "收藏",
            type: "line",
            stack: "总量",
            smooth: true,
            data: add_to_fav_count,
          },
          {
            name: "转发",
            type: "line",
            stack: "总量",
            smooth: true,
            data: share_count,
          },
          {
            name: "阅读",
            type: "line",
            stack: "总量",
            smooth: true,
            data: int_page_read_count,
          },
        ],
      });
      this.chart.resize();
    },
    getData() {
      this.loading = true;
      // 用户 chart
      content_chart({ id: this.blogId, time_range: this.dateRange }).then(
        (res) => {
          this.loading = false;
          if (res.code === 1) {
            this.createChart(
              res.list.ref_date,
              res.list.int_page_read_count,
              res.list.share_count,
              res.list.add_to_fav_count
            );
          } else {
            this.$message.warning(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style scoped></style>
